<template>
  <div class="home">
    <div class="banner-box">
      <ul class="banner-list">
        <li>
          <img src="./img/banner-home-back.png" class="banner-image" />
          <div class="text-area">
            <!-- <div style="font-size: 55px; font-weight: bold; margin-top: 57px">
              SERVING INDUSTRY
            </div>
            <div style="font-size: 44px; font-weight: bold">CREATING VALUE</div> -->
            <div style="font-size: 48px; font-weight: bold; margin-top: 145px">
              <!-- 服务产业 防控风险 创造价值 -->
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="feature">
      <ul>
        <li>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABrklEQVRYR+2XvU4CQRSFz91NKGhMrNRGO1t/OiLIG0AjJnZ2xkcwyv7gO9BamUilPgEyiZ1S22mjViY2FCRwDRsXAdmdn11DTJh67jnfnLl7d5cw40Uz9kcigMIZbw4O0KpR2/QgxgD5KpcYaAyMCagIn25MIIwA8h6XuIcGAZmBKQNdUwhtgEnz8NQBhI2KcPSS0AKIMk8CoQwgMzeFUAJQNTeBkALkXS5zH1dhw6l2etATFvaFS9dxNbEApuZjSUggIgGSmqtCTAVIy1wF4hdA2uYyiDGAvzKPgxgChLNdt9tVn4pRCIuw1/Lo9vs9Amy7nM328QpgQVfQcP9nx8LKg0udIIGiw0s9xpuhmFGZTVhuevT+cwUO18E4MlLTL6oLn46HVxDWFx1e6wGLzLgkYF1fN7qCgSciHNjAR9Oj53Dn9DlQ5UcAwddOiqstfNqa1PvHAIzDkdOUQChL0ko3AeHTML2dKjsEuHOAeQJpJnAHoBAnaNCELeHTrtIcyJ3zKnVRtDj6103U6CIUy53whm1jIwq4T2DOoHl/Si9KAClOP6mU9KtYqpBwwxf10+oh+DSvGAAAAABJRU5ErkJggg=="
            class="feature-icon"
          />
          <div class="feature-text">央企控股</div>
        </li>
        <li>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAC5UlEQVRYR+2XW4hUdRzHP9+zPXiJqBZELSjCbuDlIUHNmWEpLHrsoXooyOgCiiCID2LtOXPOqCAE+aAQXcigIuqhxyhBYs5umwVBV8IUQXHVQA3xhuycb8zsBWeYWfbMGPuyv7c//9/lc76//+2IWTbNcn3mAKZVYCDyvDGzVWa1RF/edmVwMgvY831Z/3SKnRagGPpz4IW8hZv8xeE01pO5AQqRH1DGMYRsPlNAx6/okPxOzEbAyni4ukt/t/PrqEBx0CEiBk6l4n5iZfmUsAohJwT3IZI0VpQPIPRR4EHB3mqiHfmKj3sXI+/G7ASOp4mWzRhgIPLamhmpB2Rm+XBFf3QDUHrLjzrgz0asKaQVDbfmaduCUuQDNpsRP6exHuum+GRMKfRPhtWId9NYmzoCrIu8LIDFF+HHfjMK9APb0kTv9Aiw1bAPuHBeLLkrY00WcGYk1rF63ikFSpG/sdlgOCJYC4zdGOPeI3t0rheAx8te1JdxGrhN4gebNRKHqrGebgYY9A6LN4Hbx1tGJrjUS/HJWMMdgmBifNmwayjR3iaA+mCg7OW1jN9uRdFOOfoCVnxX1u+T802LsBT6VcMH/yeA4LVqog/bAhRCR4LyFIAx4hqwoEuoq5j59dP0pnaUhxLVD7iGNSnQCmCx4QJU+zO+RjyRC8IcPh/wzN1QkjnUFUAm7hmONVoM/R7wOnAdOAssBua1ALXOvZ8memN95KWBG7ugYYaZKwAcRfxKxrOMX8cfp4k2FkMfBF5uAWieMzUCvsKsBB7qFqC5hjiYxnplXdmP9LmhwpTVxNmRsv4qRv5o4hZs27G8CrQm+TRN9NJ0a6EY+hPgxU4+vQLkWoftnOcA8iowKuV+ijUpb7MIWDqjXXDTM2xyzz4/lOjLXhpfCP2c4IupHCZKK0ran4SDXiUxOLHn/51/hS3fvq0rvQA8td0Lry1kP1B/pNZsKkMV/dIWoJdC3cbO/ZrNugL/AUktMDAQcrc8AAAAAElFTkSuQmCC"
            class="feature-icon"
          />
          <div class="feature-text">整车融资租赁</div>
        </li>
        <li>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEK0lEQVRYR8WXfWhVdRjHP9873WJaoPbijCAyQiVnJb3Qdq5GrxZRGRVlRRasIAQpEyt3juesgb1IVBSRxShYDKQMelmk0XbPlhWDtFATM4siUXKyClNz94nfnGu7L7v3KOLvr3vOeZ7v831+v+/z/J4rTvLSSY5PYgJzA5t82HhDcB5w1mACuzF2ZlM83B3q9yRJJSbgBbYY48UiQZbGkZ4/0QRaMB4oEqQ1jnTvCSMwe4VVV2fpAaYXCbK9QlzSEervckkUPAIvsBkyZh4U7V+H+pM7rKJ+OosFS4EzS4D3YqyqSPFcR6jDdUvtVKqYx1g2d/vanOubR8B7ymoYw3fA6cA/wEfAFKCu3KycnaDHYAdwM1AN9FaIWR2hfhuOk0PA5Pm0A9cnCZbA9vM45FokO+ozgoC3wm4ly9oEgIlNU3BnZ6Q1BQmkfdtgcEUZqFtS4i0TGzkMJmoRC4HaUr4SPZlQl+YRqA/sAhnbSgEYNHdtJWCN+kfYBpbyjKeB8IgEiq+scWF30xFBDhnOCKxyEqzDSBdzlXgtE+pRVxXp6TyShVsEKcGHKfGqU70X2CqMx0aJ3z1+H1e3v6KDIwi4h/MXWVXNRN7EyG8mxl9V4zhn/TL1eb61AXeNCCI+iEPdNjew8f3GL8DEPBKirQIWdoQ6UFADR196vv0ITB0OYOL9rlC3z2k0LysyhTJMwXWdkdbVB9Yq454cm11xxNnwfwXk7cAwArtzG45gVSbSkrRvjxu8UIiAYHkmUnPat2eMAT0MLYP9XZHG5foV7oS+7QHOyDFeHUdqqPftPsE7Rc64IY602vPtZWBRjs3+OAGB7U4SOQDb4kjTXGtNncIPg91xuMkeO8S0rpXa5/m2Ka8kjV1xk1xHzZHOsMfZDTZ2XA2vm/FgkTOe3xlpbbrRZppoBWYO2m2VsSDTpG/rfJuXgk+K7NDbe0XDllCH8kQ4N7Ax/dCOcc0oJfQHYk4caouzuXK5Ta2sQB2hnGhxvYQsGWloUMmDMviiV9xwlMSQBsptREAfYkXVAVrWP6s+F+HywE6rhPsxImDCKAkMfJJRm2nS93lV4Pn2lcMrBTDw3fgX8bP7ZXCuoLIcP8HGTKSL847AvUgHNt+M98oBOlYbMxZ0NendggTcteI18hkaVQfHGts1/kwMVxEqW4QA1AU2JWUDA8kkg0MyPkVMBi5LGHmT4CczbkRUYfT1Z5n1ZbNcmx5aBRuRK7OsuKhffLwhVO9AhRhPAEsK9viRzJxIX9oLzU7p9ctsgsZyk2CzK9PcJBKN5YMXzTejDKU7qqqZ7S6scncrEQEH6jVaCyoylhttcZPuLjd4XhmW4+g12mJU+I+JxJOZUCvLwSkqwlLOg1Nzy+B17UZ0t4u7DXam+nko06xfS2GUFGESgOO1TayB4w2Y6/8fNXJvMIdRMHcAAAAASUVORK5CYII="
            class="feature-icon"
          />
          <div class="feature-text">设备融资租赁</div>
        </li>
        <li>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACX0lEQVRYR9WVz0tUYRSGn3dkghKkTdg/0CIIWpREMVcX0Q8ipIUtwiBIqIUbFxkJNeOdCVtYRKskalEQRAYtoqIWqXdEcyERRIJQqxZFUBGlpeOcUEYYhtH73ZkRabbfe9/n4Tv3nhHr/NM68/kPBVIW84zXQJPz7YkHWV8nyuUj30Bzyk6bcccZDh9zomnc17eqBfakrCFuTAsaXQQMZuLGvqGM3q6Uj3QDXsr6Mc65wBczgpNBWvdXyzsLNGdsW36ed4INLgKCG0FaXWFZZwEvZU8wjoYVFs6DOrF/2FcuLO8kkLhohxXjeVhZ4fzTXI7dE3364pIPFdh1xuKbtrL4Em13KPxrRstoRhMO2aVIqIB3yboQ150Kje+IqbKfm/E4yOhq6dmqAl6PbSHONLDZSWClkPFqYwOtL7v1O5JAImkDgrNVweFpnWgb9vUn0iJKpG2n5plE1FUhMDjzmfbJW5qPvIi8pA0DLZXCBXcbp+gYHNRC5EXUkrTjeXhYKRy4mU3TCbKwjrIvoddrx7TAjuKH8zHqZVwIK0T0Z32dD80VAqGf4XJRc8oOmvFitWKD3tG0fFe40x5YLvOS1gf0rFBugu4grWtR4FEFxoC9pQCDvERn1tdAVLizwMF+q5/9ubTl4iWQnMXoGO3VvUrgzgLl5m8wJ9Ge9fWoUrizQJn5z0q0Bb6eVQOPIlA8/18xaB1Ja6hauJNAyfx/xIwjIxmN1wLuJFA0/68yDgUZvakV3EmgMP9TiANZX+9rCXcSSCTtdj7PlbHL+lBruJPAWkCLO53/C9ZKZN0F/gE8p8IhfA28zgAAAABJRU5ErkJggg=="
            class="feature-icon"
          />
          <div class="feature-text">辐射全国</div>
        </li>
      </ul>
    </div>
    <div class="who">
      <img src="./img/asset-1.df8d8b7.png" />
      <div class="who-text">
        <h2>我们是谁？</h2>
        <p>中国兵器装备集团融资租赁有限责任公司</p>
        <p>兵装集团直属成员单位</p>
        <p>
          中国兵器装备集团融资租赁有限责任公司作为兵装集团直属融资租赁企业，立足服务产业战略定位，建立以汽车融资租赁为主，以设备融资租赁为辅的整体业务布局，为用户提供专业、高效的金融服务。
        </p>
      </div>
    </div>
    <div class="business">
      <div class="business-text">
        <h2>我们的业务？</h2>
        <div class="business-title">车辆融资租赁业务</div>
        <div class="business-detail">
          <span>回租</span> <span>直租</span> <span>经营租赁</span>
        </div>
        <div class="business-title">设备资租赁业务</div>
        <div class="business-detail">
          <span>直租业务</span> <span>回租业务</span> <span>厂商租赁</span>
          <span>其他租赁</span>
        </div>
        <button class="business-more" @click="jumpToBusiness">
          <span>了解更多</span> <i class="icon-arrow"></i>
        </button>
      </div>
      <img src="./img/asset-2.d7c4022.png" />
    </div>
    <div class="advantage" id="advantage">
      <h2>我们的优势？</h2>
      <ul class="advantage-list">
        <li>
          <img
            src="data:image/png;base64,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"
            class="advantage-icon"
          />
          <div class="advantage-title">行业融资租赁经验丰富</div>
          <div class="advantage-detail">
            致力于整车、设备融资租赁服务，聚焦整车、设备等专业领域，可为客户提供高效优质的服务。
          </div>
        </li>
        <li>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAxCAYAAABODiB6AAAEYUlEQVRoQ+2ZaYjVVRjGf0+b0kJlhGL7gkFFRH3ICgNpUdQ2w4KiolWKgowoDIq07UuRWEZaVBRRnzKikhYosg9l0E5RRGQ7RRZpu/XEM51r13Hmzv/e+7/jBPPCMB/m/M/5nXfOec/7Pq/ogdkeD5wCfA8sl/RXncuozskyl+2DgKeBJ4F9gHHAqZK+rWutWqFt7wW8BFwu6amyiXnAZcBsSW/XAV4btO09geeBmyU91AxneyawFLhRUn53ZbVA2z4AWAEslPTgQERlU48C3wGXSvqqU/KuoW2fBNxdjsTyViC2twRyXPKzELhX0t/twncMbXsr4KYSJeZIerfq4rb3BxYBu5fNrqz6bcZ1BG37GGAJENC5kta2s2hjrO1pwDRJV9qeIOmbKvO0BW37YOBa4LDioVy8rq3E9dfLRV4i6Y1Wkw4JbXsMcHwuD5ALdwewTNIfXdM2TWB7O+BCYDowC9gViPff6r/OJtC2twEmAUcAxwLHAfFCosLjdb9ug23c9lHAXcBOwBPAc8BKST/L9hzg+vJxBuwAfFxAX87rJumnOr3azly286qeXJx3JLAg0DmjeWpzsX6U9EM7kw7nWNvnAYc3oJF0y3ACdLLWKHQnXuvkm5572vazwIw6o81wQKcAmCjp9068OkjS1duLaHsUOp4fPR6DnL/R49H18SgFQLKwVvY+cCjQKhtc00506epM2z4HuG4I6CQ6n+b+tBi3VNJtVUNiM/TVwFhJqdlqsx6FvIuAA5MwJbnfW1Lga7MeQacgHhfoM4GpkrKL2qxH0AuAdYGeDNwqaWptxP8+BL0IeQ+nigl0CoD3JE38H0CvAi7oqxFtf5SCUtIndYHX7Wnb2wKfA+Mb0MuAVyXdP4KhU2BfJWl6A/pE4BJJM2qEvqGvCJVaxenKy9lODfuhpMUN6K2L6w+pU0euTDTEwPICfxaRKCrUBt3D9u3AWknx0Igy22cBp0uKlPCflmc7YmBu5yRJ60YKte049s0I85Je2Qi6RJE7+4K3NH8EQZ8NnCspF7HPNpLFbO+cmB01R9IHmxvc9o7AO8BMSeHaFLp4+wzgGmBy3SJju06w/QiwWlJUsA02oGpqO/F6vaSL212orvG25+b1A46W9GcV6LFFK16xOeSyIrbfA0yR9EV/RwyqT9veBXgReGw4wW1Hn76vnOMBW3gtRfWSTKVrFX16Xv9/U11HoTGP7fOBvBOzJOUCDmhVOgFJVNL727eEnmjXtZrtaOJ53NIWOU3S6lYLDAnd5IVcipRkyQEWSfqlDnLbswtw1P75kn4bat7K0CUcTkhHNh0pYDHwgKQ0M9uy0iJJwz8lXjaf7C2vcSVrC7rJ6/sBVwBpfWSxKKTpiScLWz/QyrZ3A9JHOaE0gl5LT0XSC5VImwZ1BN0En85XIPLETgGyma+BtECSv+TvedX2ANaUC5023jNVe4YDbagr6P4T2t4CiEfTcNoeiMybJtOXkn5t16ODjf8HB2IkEZhzyU0AAAAASUVORK5CYII="
            class="advantage-icon"
          />
          <div class="advantage-title">风险管控能力强</div>
          <div class="advantage-detail">
            公司有完善的风险管理及内部控制程序制度；结合风险管理业务特性，通过全面尽职调查、独立资料审阅、多层级审批、法务合规等手段全面管理经营风险。
          </div>
        </li>
        <li>
          <img
            src="data:image/png;base64,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"
            class="advantage-icon"
          />
          <div class="advantage-title">央企强大背景，资本基础强劲</div>
          <div class="advantage-detail">
            公司拥有国家央企强大背景，资本水平健康，资本基础强大，融资能力和征信声誉良好，助力公司长足发展。
          </div>
        </li>
        <li>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAxCAYAAAClOZt5AAAE+UlEQVRoQ+2aaahWVRSGn7eBgn5kZUiDaEaFTRTRRKFhg0QiNGGFDdicoc2WGf2ITLGE0n5k5VA0UNAcBA3SaPMAUWTZSEn0o4jqR9Mb7737s+PXvX7n2M2+H3fB5cJ39lr73eusvda71z6iH7G9KTAa2AH4FfhQ0jf9jR+I322PBHYBNgE+B1ZK+qMv22r/sShfCRwHfAZ8AWwG7A38AiwAbu/PYNMF2N4cuBA4H/gd+KD83xnYDrgPmCvp26rttYDbPh2YDcwH7pT0Q3Ww7X2Ba4DtgRMlfdUUaJu93YEHgdeBOZI+ans+rCzoLOA8SU+0nq8BbjsPLwXGS/pyXYBsnwNcBoyVtHp9wNveFXgGmC7p4Q7z7QE8CUyT9FjG9gC3nQdPAQfWjWPbWeQ4Scc0BW57Y+DVvFlJCYWOYjv77emC8esW8Kz4EUnLOlooA2xvVCafKSmeqy22Ty2hNrG2Uq+DrwJ2lDRVthNHbwMjJf3W0NBk4ChJpzXUy0JnS3quod4Q4ONkugBP9shGO7mJkRJieeVZ8KomuolvSSub6LTG2n4emBHg04Bhkq5eH0MbWsf2kmzUAJ9egM/c0CDWZz7bS1vAjwbOlpSQaSS2ewqTpDeaKNo+BFgh6c8meiU8V/TkdNtbpZwDoySlMtYW21OB/SRNqa3Umx2Sem/rlL/bbdpOJX0LGNFKh3cDb0q6uS6AwmXeB6ZIermuXvHaCSk8wBhJrqtre27GSprRAj685OQjJMX7HcV2FrmlpDM6Dm4bYDvzxuvLJc2po1/C6x5gn1CRaslPMbgl5EpS8nqfUqpe+MyRwKFNw6tl1PY2xVmLJM1bF3jb44C7gEmtt9tOssYDi4CHgFslfVKZKFTzWODyQjkTIj/V8dY6nLAtcC+QKnxT3kJ1w9req4TUWGCypNdatvqitVsDFwBhiqGc4eDh5jtlHwALJT36bwBXdQt1OAU4Fwhn+hQIBx8BfAcsjjMl/VzV+wfwNqPxSP5iaJWk8OX/TEp6HVXI32pJ3/c32TqB/2cIB8DwIPABcGIjE4Meb+SuARhcLUAH5zQN7Fbyaifz2fGpZNetJ1k6Kbw6J5pOE5XnScs3Sgo9WXPmTBV7FzgTCO+ow9qGAncAj0taWHPynmG29y+FJ5yl7oEi7Yp0BMJkX2pxlQmlMsULtcV2KtoVTQ/Mtmeld1KXp1Sq90XAUEmzWsAnlbZEU3oaz82TdFjt1fZ6/IZUZElpLtWW0hYZLeniQeC13fa3x1PSw0Zry0B6PHQzbbHQ236pcBWZ7XCfnNSXSeo5GNSVgQSeGL+/NEUndgJfQD9bWOeC/z3Gk8vjQaBf8BXQOaXH692xOW0f3h/4KmhJ87suq/QFvh10KUDdlw6r4IH0zxPTS+PpSiHpPuDFo62wycXA4irorvV4AZbN90Jae0BaHmulyq6L8QronvAA3utrw3Yd8NIrWV6N6UrMT5AUBtp9XMX2nsABktJSWCOFRQ5ptTW6zuMNSnd3ZpVOCxj0uO3Bg0SnMOnKrFIH9EADHwNcKymlurbYzin9+KZXjeXCbLikXKvXFtvXAz/mANI6c6b3/Uq5qE17os71Rloal5TuwIu1Z+8tQKEC+fAg1TUXrnUk7Yl8b3CQpN4r8fL6tkjPojSE6rTm0hB6QNI7dWZtH2M7X2Ckj5PvYepIGkJLWl9s/AVcGiBoDp3FDAAAAABJRU5ErkJggg=="
            class="advantage-icon"
          />
          <div class="advantage-title">多元化客户市场基础</div>
          <div class="advantage-detail" style="margin-top: 6px">
            公司积极开展机构业务、自然人业务，与长安轿车、长安福特等集团主机厂有长期业务合作协议；积极开通零售业务网络，目前开通
            384家经销商渠道入网，遍布于中国逾21个省（自治区、直辖市），116个城市。
          </div>
        </li>
      </ul>
    </div>
    <div style="width: 100%; height: 72px"></div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
const route = useRoute();

export default {
  name: "HomeView",
  components: {
  },
  methods:{
    jumpToBusiness(){
      this.$router.push(`/business`);
    }
  }
};
</script>
<style lang="less" scoped>
.banner-box {
  position: relative;
  width: 100%;
  padding-top: 62px;
}
.banner-list li {
  position: relative;
  width: 100%;
  height: 494px;
}
.banner-image {
  width: 100%;
  height: 494px;
}
.text-area {
  position: absolute;
  width: 639px;
  height: 354px;
  //background: rgba(55, 61, 65, 0.14);
  top: 59px;
  left: 189px;
  color: #fff;
  text-align: center;
}
.dot-list {
  position: absolute;
  width: 639px;
  left: 189px;
  bottom: 27px;
  text-align: center;
}
.dot-list li {
  display: inline-block;
  width: 86px;
  height: 6px;
  background: rgba(164, 182, 205, 1);
  transition: all 0.3s;
  margin: 0 9px;
}
.dot-list li.active {
  background: rgba(255, 255, 255, 1);
}
.feature {
  padding-top: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(191, 191, 191, 0.4);
}
.feature ul {
  text-align: center;
}
.feature ul li {
  width: 237px;
  height: 66px;
  display: inline-block;
  text-align: center;
  border-left: 1px solid rgba(151, 151, 151, 0.4);
}
.feature ul li:first-child {
  border-left: none;
}
.feature-icon {
  width: 32px;
  height: 32px;
}
.feature-text {
  font-size: 20px;
  color: rgba(120, 118, 118, 1);
  margin-top: 4px;
}
.who {
  width: 100%;
  height: 436px;
  text-align: center;
  padding-top: 101px;
  box-sizing: border-box;
}
.who img,
.who-text {
  display: inline-block;
  vertical-align: top;
}
.who-text {
  width: 414px;
  text-align: left;
  position: relative;
  top: -8px;
  margin-left: 86px;
}
.who-text h2 {
  margin-top: 0;
  color: rgba(61, 126, 255, 1);
  font-size: 32px;
}
.who-text p {
  color: rgba(120, 118, 118, 1);
  font-size: 18px;
  line-height: 1.5em;
}
.business {
  width: 100%;
  height: 603px;
  background: rgba(212, 235, 255, 0.2);
  text-align: center;
  box-sizing: border-box;
}
.business-text {
  width: 466px;
  display: inline-block;
  text-align: left;
}
.business img {
  display: inline-block;
  position: relative;
  top: 10px;
}
.business-text h2 {
  margin-top: 67px;
  color: rgba(61, 126, 255, 1);
  font-size: 32px;
}
.business-title {
  font-size: 20px;
  color: rgba(129, 130, 131, 1);
  font-weight: bold;
  margin-top: 50px;
}
.business-detail {
  margin-top: 25px;
}
.business-detail span {
  display: inline-block;
  margin-right: 20px;
  background: rgba(61, 126, 255, 0.08);
  border-radius: 2px;
  color: rgba(61, 126, 255, 1);
  font-size: 18px;
  width: 89px;
  height: 42px;
  line-height: 42px;
  text-align: center;
}
.business-more {
  cursor: pointer;
  min-width: 145px;
  max-width: 160px;
  height: 42px;
  background: transparent;
  border: 1px solid rgb(61, 126, 255);
  outline: none;
  border-radius: 2px;
  margin-top: 63px;
  transition: all 0.3s;
}
.business-more:hover {
  background: rgba(61, 126, 255, 0.36);
}
.business-more span {
  font-size: 18px;
  color: #3d7eff;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  margin-right: 5px;
}
.icon-arrow {
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAvUlEQVRYR+2VMQoCMRBF/3e9hKWHsNsV72Cxde4hg0E8gGAtW3oMca0tPIHXsBpJsTEsiCBkt5k0aUL+4/0hIUZeHDkfBmAGzIAZMAPZDVSiJwCuIOYXz2f/6c8PsNcZXrgq8bh5rgcHCIFL0VqBMxSu3bFJIbIb6MJK0SOBuiAWaRURoNzoKvfXzAkOIO6tp+uyIkAlqrkB4v1JFR8DotsfAAEwnO/vf3FPiSZUMdgMfKM0ADNgBsyAGTADb8eBKyHGcC/+AAAAAElFTkSuQmCC") no-repeat 0 0 /
    100% 100%;
}
.advantage {
  width: 100%;
  height: 829px;
  background: url(./img/advantage-bg.9bc6004.png) no-repeat 0 0 /
    100% 100%;
  padding-top: 49px;
  text-align: center;
}
.advantage h2 {
  color: rgba(61, 126, 255, 1);
  font-size: 32px;
  margin-top: 0;
}
.advantage-list li {
  vertical-align: top;
  display: inline-block;
  width: 422px;
  height: 278px;
  background: rgba(61, 126, 255, 0.72);
  border-radius: 8px;
  margin: 19px 21px;
}
.advantage-icon {
  margin-top: 31px;
  margin-bottom: 11px;
}
.advantage-title {
  font-size: 20px;
  color: #ffffff;
  font-weight: bold;
}
.advantage-detail {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.77);
  width: 362px;
  text-align: center;
  margin: 26px auto 0 auto;
  line-height: 28px;
}

</style>
